import Nanobus from "nanobus";
import AcHtmlElement from "../helpers/html-element";
import AcHookableFilters from "./ac-hookable-filters";
var AcServices = /** @class */ (function () {
    function AcServices() {
        this.services = {};
        this.events = new Nanobus();
        this.filters = new AcHookableFilters();
        this.$ = AcHtmlElement;
    }
    AcServices.prototype.registerService = function (name, service) {
        this.services[name] = service;
        this.events.emit("Service.Registered." + name, service);
        return this;
    };
    AcServices.prototype.getService = function (name) {
        return this.hasService(name) ? this.services[name] : null;
    };
    AcServices.prototype.hasService = function (name) {
        return this.services.hasOwnProperty(name);
    };
    AcServices.prototype.addListener = function (name, callback) {
        this.events.addListener(name, callback);
    };
    AcServices.prototype.emitEvent = function (name, args) {
        this.events.emit(name, args);
    };
    return AcServices;
}());
export default AcServices;
